/* eslint-disable import/prefer-default-export */

// TODO: Move the file type check to the server such that this is just an icon/color selection in here.
export const iconMapper = (ext, theme) => {
  switch (ext) {
    case 'doc':
    case 'docx':
    case 'docm':
    case 'dotx':
    case 'dotm':
      return { icon: 'file-word-o', color: theme.palette.facet.msWordBlue, label: 'Word Document' };
    case 'xls':
    case 'xlsx':
    case 'xlsm':
    case 'xltx':
    case 'xltm':
      return { icon: 'file-excel-o', color: theme.palette.facet.msExcelGreen, label: 'Excel Spreadsheet' };
    case 'ppt':
    case 'pptx':
    case 'pptm':
    case 'potx':
    case 'potm':
    case 'ppsx':
    case 'ppsm':
    case 'sldx':
    case 'sldm':
      return { icon: 'file-powerpoint-o', color: theme.palette.facet.msPowerpointOrange, label: 'Powerpoint Presentation' };
    case 'ogg':
    case 'mp3':
    case 'm4a':
    case 'aac':
    case 'wma':
    case 'flac':
      return { icon: 'file-audio-o', color: theme.palette.facet.accentBlue, label: 'Audio File' };
    case 'mp4':
    case 'mov':
    case 'wmv':
    case 'avi':
    case 'mkv':
      return { icon: 'file-video-o', color: theme.palette.facet.accentBlue, label: 'Video File' };
    case 'zip':
    case 'gzip':
      return { icon: 'file-archive-o', color: theme.palette.facet.accentBlue, label: 'Archive' };
    case 'pdf':
      return { icon: 'file-pdf-o', color: theme.palette.facet.pdfRed, label: 'PDF' };
    case 'gif':
    case 'apng':
    case 'ico':
    case 'cur':
    case 'jpg':
    case 'jpeg':
    case 'jfif':
    case 'png':
    case 'svg':
      return { icon: 'file-image-o', color: theme.palette.facet.accentBlue, label: 'Image' };
    case 'txt':
    case 'text':
      return { icon: 'file-text-o', color: 'black', label: 'Text File' };
    default:
      return { icon: 'file-o', color: theme.palette.facet.accentBlue, label: 'File' };
  }
};
